import { SpaceContext } from '@eggplant/context'
import { SHARED_SPACE_ID } from '@eggplant/routing'
import { useContext } from 'react'

export const useGetFormDataWithSpaceId = (params: FormData | undefined) => {
  const spaceContext = useContext(SpaceContext)

  if (import.meta.env.VITE_IS_AUTH_DISABLED === 'true') // do not add spaceId into test environments (eg. cypress)
  {
    const requestParams = params

    return { requestParams }
  }

  const spaceId = spaceContext?.selectedSpaceId || SHARED_SPACE_ID

  const requestParams = new FormData()

  if (params) {
    params.forEach((value, key) => {
      requestParams.append(key, value)
    })
  }

  requestParams.append('space_id', spaceId)

  return { requestParams }
}
